var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditedReservation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4495V13.8561C0 14.0778 0.174167 14.252 0.395833 14.252H2.8025C2.90542 14.252 3.00833 14.2124 3.07958 14.1332L11.7246 5.49615L8.75583 2.5274L0.11875 11.1645C0.0395834 11.2436 0 11.3386 0 11.4495ZM14.0204 3.20031C14.3292 2.89156 14.3292 2.39281 14.0204 2.08406L12.1679 0.231562C11.8592 -0.0771875 11.3604 -0.0771875 11.0517 0.231562L9.60292 1.68031L12.5717 4.64906L14.0204 3.20031V3.20031Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditedReservation);
export default __webpack_public_path__ + "static/media/edited-reservation.8471b15ec39e4c643f3267eb85b9c06b.svg";
export { ForwardRef as ReactComponent };